import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class LoginService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.configService = configService;
        this.httpClient = httpClient;
    }

    public async createLoginRequestWithPhoneNumber(phoneNumber: string, isVerifyRequest?: boolean): Promise<{ id: string; maskedPhoneNumber: string }> {
        const requestBody = isVerifyRequest ? {
            phoneNumber: phoneNumber,
            isVerifyRequest: isVerifyRequest
        } : {phoneNumber: phoneNumber};
        return this.createLoginRequest(requestBody);
    }

    public async createLoginRequestWithPan(pan: string): Promise<{ id: string; maskedPhoneNumber: string }> {
        const requestBody = {pan: pan};
        return this.createLoginRequest(requestBody);
    }

    public async createLoginRequestWithUserId(userId: string): Promise<{ id: string; maskedPhoneNumber: string }> {
        const requestBody = {userId: userId};
        return this.createLoginRequest(requestBody);
    }

    public async verify(loginRequestId: string, password: string): Promise<{ userId: string; token: string }> {
        const url = this.configService.getUserServiceUrl() + `/verification-attempt`;
        const requestBody = {loginRequestId, password};
        return this.httpClient.post<{ userId: string, token: string }>(url, requestBody).toPromise();
    }

    private createLoginRequest(requestBody: { phoneNumber?: string, pan?: string, userId?: string }): Promise<{ id: string; maskedPhoneNumber: string }> {
        const url = this.configService.getUserServiceUrl() + `/login-request`;
        return this.httpClient.post<{ id: string, maskedPhoneNumber: string }>(url, requestBody).toPromise();
    }

    createVerificationRequest(phoneNumber: string, userId: string) {
        const requestBody = {phoneNumber: phoneNumber, userId: userId};
        const url = this.configService.getUserServiceUrl() + `/login-request/verification`;
        return this.httpClient.post<{ id: string, maskedPhoneNumber: string }>(url, requestBody).toPromise();
    }
}
